export default __webpack_public_path__ + "static/media/Jo_avatar.b4868e8b.png";